// extracted by mini-css-extract-plugin
export default {"actionsCell":"style_actionsCell__6Lfos","buttons":"style_buttons__cmI5g","deleteButton":"style_deleteButton__bPEj3"};